import { render, staticRenderFns } from "./CampaignsWorkflows.vue?vue&type=template&id=33c74918"
import script from "./CampaignsWorkflows.vue?vue&type=script&lang=js"
export * from "./CampaignsWorkflows.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports